import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, ChangeDetectorRef, OnChanges } from "@angular/core";
import { SharedService } from '../../shared';
import { CannabisOption, THC_CBD_Group, PartnerNamesEnum } from '../shared';

@Component({
    selector: 'inhalativ-oral',
    templateUrl: "./inhalativ-oral.component.html",
    styleUrls: ["./inhalativ-oral.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class InhalativOralComponent implements OnInit, OnChanges {
    @Input() partnerName: string = "";
    @Input() selectedOption: CannabisOption;
    @Input() secTwoQuestOneGroup: THC_CBD_Group;
    @Output() onSelectOption = new EventEmitter<any>();

    activeBlock: '' | 'INHALATIV' | 'ORAL' = '';

    PartnerNamesEnum = PartnerNamesEnum;

    inhalativOptions: CannabisOption[] = [];
    oralOptions: CannabisOption[] = [];

    get isPartnerPage() {
        return this.partnerName && this.partnerName.length;
    }

    get GroupTitle() {
        return (this.secTwoQuestOneGroup && this.secTwoQuestOneGroup.Title) ? this.secTwoQuestOneGroup.Title : "";
    }

    get isTHCCBDSelected() {
        return this.GroupTitle && this.GroupTitle.length > 0;
    }

    get IsTHC() {
        return this.GroupTitle && this.GroupTitle.indexOf("THC") > -1;
    }

    get IsDronabinol() {
        return this.GroupTitle && this.GroupTitle.indexOf("CBD") === -1;
    }

    get IsTHCAndCBD() {
        return this.GroupTitle && this.GroupTitle.indexOf("THC") > -1 && this.GroupTitle.indexOf("CBD") > -1;
    }

    constructor(private sharedService: SharedService,
        private cd: ChangeDetectorRef) {
    }

    ngOnInit(): void {
    }

    ngOnChanges() {
        this.setOptions();
        this.setActiveBlock();
    }

    setOptions() {
        this.inhalativOptions = [];
        this.oralOptions = [];

        switch (this.partnerName) {
            case PartnerNamesEnum.ALTHEA:
                break;
            case PartnerNamesEnum.FOUR_20_PHARMA:
                if (this.IsDronabinol) {
                    this.inhalativOptions.push({ Label: "Cannabisblüten Inhalativ" });
                }
                break;
            default:
                this.inhalativOptions.push({ Label: "Cannabisblüten Inhalativ" });
                break;
        }
        this.oralOptions.push({ Label: "Cannabisextrakt Tropfen" });

        if (!this.partnerName || this.partnerName == PartnerNamesEnum.AVEXTRA) {
            if (this.IsTHCAndCBD) {
                this.oralOptions.push({ Label: "Cannabisextrakt Kapseln" });
            }
        }

        switch (this.partnerName) {
            case PartnerNamesEnum.AVEXTRA:
                if (this.IsDronabinol || !this.isTHCCBDSelected) {
                    this.oralOptions.push({ Label: "Ölige Dronabinol Tropfen" });
                    this.oralOptions.push({ Label: "Dronabinol Kapseln" });
                }
                break;
            case PartnerNamesEnum.ALTHEA:
            case PartnerNamesEnum.FOUR_20_PHARMA:
                break;
            case PartnerNamesEnum.BETAHEALTH:
                this.oralOptions.push({ Label: "Cannabisblüten Tee" });
                break;
            default: {
                this.oralOptions.push({ Label: "Cannabisblüten Tee" });
                if (this.IsDronabinol || !this.isTHCCBDSelected) {
                    this.inhalativOptions.push({ Label: "Ethanolische Dronabinol Lösung" });

                    this.oralOptions.push({ Label: "Ölige Dronabinol Tropfen" });
                    this.oralOptions.push({ Label: "Dronabinol Kapseln" });
                }
                if (!this.IsTHC || !this.isTHCCBDSelected) {
                    this.oralOptions.push({ Label: "Cannabidiol Kapseln" });
                    this.oralOptions.push({ Label: "Ölige Cannabidiol Tropfen" });
                }
            }
        }

        switch (this.partnerName) {
            case PartnerNamesEnum.ADREX:
            case PartnerNamesEnum.AVEXTRA:
            case PartnerNamesEnum.ALTHEA:
            case PartnerNamesEnum.BETAHEALTH:
            case PartnerNamesEnum.SWISS:
            case PartnerNamesEnum.FOUR_20_PHARMA:
                break;
            default: {
                this.oralOptions.push({ Label: "Fertigarzneimittel Spray" });
                this.oralOptions.push({ Label: "Fertigarzneimittel Kapseln" });
            }
        }

    }

    setActiveBlock() {
        if (this.inhalativOptions.find(a => a.Label == this.selectedOption.Label)) {
            this.activeBlock = 'INHALATIV';
        } else if (this.oralOptions.find(a => a.Label == this.selectedOption.Label)) {
            this.activeBlock = 'ORAL';
        } else {
            this.activeBlock = '';
        }
    }

    selectOption(option: CannabisOption) {
        this.onSelectOption.emit(option);
    }

}
